import React, { useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import useActions, { useAppSelector } from "../../app/hooks";
import { selectIdeHistory, selectLastIdeLocation } from "./ideSlice";

export default function IdeHistoryPanel() {
  const history = useAppSelector(selectIdeHistory);
  const lastLocation = useAppSelector(selectLastIdeLocation);
  const actions = useActions();
  const [hovered, setHovered] = useState(false);

  //if (!history || history.length === 0) {
  //  return null;
  //}

  const handleClick = (repoId: number, fileName: string) => {
    actions.openFile({ repoId, file_name: fileName });
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 10,
        left: 0,
        zIndex: 1400,
        display: "flex",
        alignItems: "flex-end",
        pointerEvents: "none",
      }}
    >
      {/* Side button that is always visible */}
      <Paper
        elevation={4}
        sx={{
          px: 0.8,
          py: 4,
          mr: 1,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "primary.main",
          borderRadius: "0px",
          pointerEvents: "auto",
        }}
        onMouseEnter={() => setHovered(true)}
      >
        <Typography
          variant="caption"
          sx={{ writingMode: "vertical-lr", transform: "rotate(180deg)", textOrientation: "mixed", fontSize: "14px", color: "white" }}
        >
          HISTORY
        </Typography>
      </Paper>

      {/* Slide-out history panel */}
      <Paper
        elevation={4}
        sx={{
          width: 280,
          maxHeight: 420, // enough for ~5 items, rest scroll
          overflowY: "auto",
          p: 1,
          transform: hovered ? "translateX(0)" : "translateX(-100%)",
          opacity: hovered ? 1 : 0,
          transition: "transform 0.2s ease-out, opacity 0.2s ease-out",
          pointerEvents: hovered ? "auto" : "none",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
          IDE History
        </Typography>
        <List dense>
          {history.map((loc, index) => {
            const fileName =
              loc.repoFileName.split("/").pop() || loc.repoFileName;
            const subtitle =
              loc.folderPath && loc.folderPath !== "/"
                ? `${loc.folderPath} • repo ${loc.repoId}`
                : `repo ${loc.repoId}`;
            const isActive =
              lastLocation &&
              lastLocation.repoId === loc.repoId &&
              lastLocation.repoFileName === loc.repoFileName;
            return (
              <ListItemButton
                key={`${loc.repoId}_${loc.dashId}_${index}`}
                onClick={() => handleClick(loc.repoId, loc.repoFileName)}
                sx={{
                  bgcolor: isActive ? "black" : undefined,
                  "&:hover": {
                    bgcolor: isActive ? "grey.800" : "action.hover",
                  },
                  "& .MuiListItemText-primary": {
                    color: isActive ? "white" : undefined,
                  },
                  "& .MuiListItemText-secondary": {
                    color: isActive ? "white" : undefined,
                  },
                }}
              >
                <ListItemText
                  primary={fileName}
                  secondary={subtitle}
                  primaryTypographyProps={{ noWrap: true }}
                  secondaryTypographyProps={{ noWrap: true }}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Paper>
    </Box>
  );
}

